import { useRef, useEffect, useCallback } from "react";
export const useAnimationFrame = ({ isPaused, callback, speed, }) => {
    const requestRef = useRef(null);
    const previousTimeRef = useRef(null);
    const speedRef = useRef(1);
    const isPausedRef = useRef(false);
    useEffect(() => {
        if (speedRef.current !== speed) {
            speedRef.current = speed;
        }
        if (isPausedRef.current !== isPaused) {
            isPausedRef.current = isPaused;
        }
    }, [speed, isPaused]);
    const animate = useCallback((time) => {
        if (isPausedRef.current) {
            return;
        }
        const fps = 30;
        if (previousTimeRef.current != undefined) {
            const deltaTime = time - previousTimeRef.current;
            const fpsInterval = 1000 / fps;
            if (deltaTime > fpsInterval) {
                callback({ speed: speedRef.current, fps });
                previousTimeRef.current = time;
            }
        }
        requestRef.current = requestAnimationFrame(animate);
    }, [callback]);
    useEffect(() => {
        previousTimeRef.current = performance.now();
        requestRef.current = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(requestRef.current);
    }, [isPaused]);
};
//# sourceMappingURL=useAnimationFrame.js.map